import { disableLoadingIndicator, enableLoadingIndicator } from './loadingIndicator';
import { getHashProperty, isMobileBrowser } from './_utils';

export function isPrimitive(v) {
	return v === null || !['object', 'function'].includes(typeof v);
}

export class ReadonlyURLSearchParams extends URLSearchParams {
	append() {
		return;
	}
	delete() {
		return;
	}
	set() {
		return;
	}
	sort() {
		return;
	}
}

export function isInFrame() {
	try {
		return !!window.frameElement;
	} catch (e) {
		// In stricter security sandboxes, accessing may throw an error; this means we are in an iframe.
		return true;
	}
}

/**
 * @typedef {{ readonly [P in keyof T]: DeepReadonly<T[P]>; }} DeepReadonly
 * @template T
 */

/**
 * Deeply freeze an object.
 * @type {<T>(o:T) => DeepReadonly<T>}
 */
export function deepFreeze(o) {
	if (isPrimitive(o) || Object.isFrozen(o)) {
		return o;
	}
	Object.values(o).forEach(deepFreeze);
	return Object.freeze(o);
}

export function getSiteContext() {
	const [tld, name, ...subdomains] = sctxLocation.hostname.split('.').reverse();
	const parsed = {
		name,
		...Object.fromEntries(subdomains.map((n, i) => [`subdomain${i + 1}`, n])),
		tld,
	};
	const inFrame = isInFrame();
	const isLocal = sctxLocation.hostname.includes('local');
	const sctx = deepFreeze({
		domain: {
			isLocal,
			isPublic: parsed.name === 'fourseasons' && parsed.tld === 'com' && !sctxLocation.port,
			isViewer: isLocal && inFrame,
			name: sctxLocation.host,
			parsed,
		},
		isInFrame: inFrame,
		isSecure: sctxLocation.protocol === 'https:',
		location: sctxLocation,
		page: {
			hash: () => getHashProperty(),
			isMobile: isMobileBrowser(),
			loadingIndicator: {
				disable: () => disableLoadingIndicator(),
				enable: () => enableLoadingIndicator(),
			},
			path: sctxLocation.pathname,
		},
		params: new ReadonlyURLSearchParams(sctxLocation.searchParams),
		port: sctxLocation.port,
	});
	return sctx;
}

export default function attachSiteContext() {
	const siteContext = getSiteContext();
	if (siteContext.domain.isLocal) {
		// Useful for debugging purposes
		window.__SCTX = siteContext;
	}
}

const sctxLocation = deepFreeze(new URL(window.location.href));
